

export const FOOTER_INFO = {
    address:'| 인천광역시 연수구 컨벤시아대로 204, 104호(인스타2, 송도동)',
    companyInfo:'| 사업자등록번호 : 107-88-42750 | 상호 : 나인와트 | 대표 : 김영록',
    tel:'070-8866-7226',
    email:'ninewatt@ninewatt.com',
}